import { Component, OnInit, Input } from '@angular/core';
import { Signature } from '../../models/signature';
import { Person } from '../../models/person';
import { faCheck } from '@fortawesome/fontawesome-pro-regular';

@Component({
  standalone: false,
  selector: 'app-view-signature',
  templateUrl: './view-signature.component.html',
styleUrls:  ['./view-signature.component.css']
})
export class ViewSignatureComponent implements OnInit {

  faCheck = faCheck;

  @Input() signature: Signature;

  constructor() { }

  ngOnInit() {
  }

}
